import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Rating,
  Box,
  Grid,
  Snackbar,
  Alert,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

const FeedbackForm = () => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    axios.post(`${API_BASE}/api/feedback`, { rating: Number(rating), comment }, {
      withCredentials: true,
    }).then((res) => {
      setSnackbar({
        open: true,
        message: res.data.message,
        severity: 'success',
      });
    }).catch((err) => {
      setSnackbar({
        open: true,
        message: err.response?.data?.error || '送信エラー',
        severity: 'error',
      });
    });
    // フォームのリセット
    setComment('');
    setRating(0);
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        フィードバック
      </Typography>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          icon={<CheckIcon fontSize="inherit" />}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography component="legend">評価</Typography>
            <Rating
              name="rating"
              value={rating}
              onChange={(event, newValue) => {
                setRating(newValue);
              }}
              size="large"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              label="コメント"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              disabled={!rating || !comment}
            >
              送信
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default FeedbackForm;

